let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aoU9B")).then(() => parcelRequire('a6OFr'));